import { render, staticRenderFns } from "./AiSettings.vue?vue&type=template&id=16421150"
import script from "./AiSettings.vue?vue&type=script&lang=js"
export * from "./AiSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports